// extracted by mini-css-extract-plugin
module.exports = {"actionsCell":"actionsCell__XyH-8"};